import React from 'react'
import { string, array } from 'prop-types'
import styled from 'styled-components'

const StyledContainer = styled.div`
  width: 500px;
  display: flex;
  flex-direction: column;
  background-color: #eee;
  padding: 10px;
  border-radius: 5px;
  font-family: Arial, Helvetica, sans-serif;

  input {
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 18px;
    padding: 10px;
  }

  button {
    background: blue;
    color: #fff;
    font-size: 20px;
    padding: 6px 25px;
    border-radius: 4px;
  }

  table {
    width: 100%;
    text-align: left;
    background-color: #fff;
    border-radius: 4px;
    padding: 10px;
  }
`

const StyledRow = styled.div`
  display: flex;
  padding: 5px 0px;
`

const StyledColumn = styled.div`
  flex: 1;
`

const FlexLayout = ({ title, rows }) => {
  return (
    <StyledContainer>
      <h2>{title}</h2>
      {rows.map((columns, index) => (
        <StyledRow key={`row-${index}`}>
          {columns.map((column, indx) => (
            <StyledColumn key={`row-${index}-col-${indx}`}>{column}</StyledColumn>
          ))}
        </StyledRow>
      ))}
    </StyledContainer>
  )
}

FlexLayout.propTypes = {
  title: string,
  rows: array
}

export default FlexLayout
